<!--
 * @Author: huanhaun
 * 课程item
-->
<template>
    <div class="item td-fss">
        <div class="avatar">
            <img :src="item.avatar" />
        </div>
        <div class="info td-f1">
            <div class="name">{{item.user_name}}</div>
            <div class="time">{{item.create_time}}</div>
            <div class="content">{{item.comment}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "courseItem",
    props:['item'],
    methods: {}
};
</script>
<style lang="less" scoped>
.item {
    padding: 10px 0;
    border-bottom: solid #eee 1px;
    .avatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        box-shadow: 0 0 2px rgba(0, 0, 0, .2);
        img{
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .info{
        margin-left: 10px;
        .name{
            font-size: 14px;
            color: #333;
            font-weight: 500;
            line-height: 20px;
        }
        .time{
            font-size: 12px;
            color: #999;
            line-height: 20px;
        }
        .content{
            font-size: 14px;
            line-height: 1.6;
            color: #333;
            text-align: justify;
            word-break: break-all;
        }
    }
}
</style>